import { render, staticRenderFns } from "./ItemHeader.vue?vue&type=template&id=268838fe&scoped=true&"
import script from "./ItemHeader.vue?vue&type=script&lang=js&"
export * from "./ItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./ItemHeader.vue?vue&type=style&index=0&id=268838fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268838fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
